import React from 'react';
import styles from '../../../assets/styles/globals.scss';

const MultipleUsersIcon = (props) => {

  let { 
    iconColor,
  } = props;

  return (
<svg xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" width="166" height="166" viewBox="0 0 166 166">
    <defs>
        <path id="mulitple-user" d="M83 0c45.842 0 83 37.158 83 83s-37.158 83-83 83c-45.84 0-83-37.158-83-83S37.16 0 83 0zm30.937 40.604c-9.442 0-17.096 7.656-17.1 17.1 0 9.454 7.658 17.1 17.1 17.1s17.103-7.644 17.103-17.1c0-9.444-7.661-17.1-17.103-17.1zm-30.94 23.039c-9.442 0-17.113 7.658-17.113 17.11 0 9.444 7.67 17.09 17.112 17.09 9.438 0 17.111-7.646 17.111-17.09 0-9.452-7.673-17.11-17.11-17.11zm-30.934-23.04c-9.443 0-17.107 7.657-17.105 17.1 0 9.455 7.663 17.1 17.105 17.1s17.098-7.643 17.098-17.1c0-9.443-7.658-17.1-17.098-17.1zM29.05 102.357h20.971c2.996-6.391 7.978-9.097 13.963-12.09a20.973 20.973 0 0 1-2.287-9.513c0-1.471.145-2.914.446-4.297a21.173 21.173 0 0 1-10.08 2.54c-6.81 0-12.867-3.215-16.771-8.208-7.679 3.829-12.22 6.243-14.173 15.783-.708 3.454-.825 6.73-.825 6.73a8.716 8.716 0 0 0 8.756 9.055zm76.967 23.04a8.71 8.71 0 0 0 8.742-9.06s-.108-3.23-.811-6.68l-.01-.052c0 .01 0 .017.004.024-1.938-9.558-6.496-11.967-14.174-15.796-3.907 4.988-9.956 8.214-16.772 8.214-6.817 0-12.865-3.224-16.77-8.204-7.69 3.825-12.235 6.245-14.17 15.829-.766 3.722-.849 6.667-.849 6.667a8.753 8.753 0 0 0 8.782 9.058h46.028zm30.933-23.04a8.724 8.724 0 0 0 8.76-9.055s-.115-3.276-.825-6.73c-1.953-9.541-6.496-11.958-14.171-15.783-3.907 4.993-9.967 8.208-16.775 8.208-3.64 0-7.065-.917-10.07-2.536.296 1.38.44 2.823.44 4.293 0 3.427-.84 6.646-2.287 9.512 5.987 2.994 10.976 5.696 13.977 12.09h20.951z"/>
    </defs>
    <g fill="none" fillRule="evenodd">
        <mask id="b" fill="#fff">
            <use xlinkHref="#mulitple-user"/>
        </mask>
        <use fill={iconColor || styles.aoDarkBlue} fillRule="nonzero" xlinkHref="#mulitple-user"/>
    </g>
</svg>

  );
};

export default MultipleUsersIcon;



// WEBPACK FOOTER //
// ./src/components/Iconoclast/MultipleUsersIcon/index.js